import React, { useState, useEffect } from 'react';
import Tabs from 'antd/lib/tabs';
import { getShouldDisplayIncentives } from 'parity-network-requests';
import { config } from '../../config';
import { SavingsHome, DownloadReport, Incentives } from './components';

import './SavingsPage.less';

const { REACT_APP_BUILD_ENV } = config;

export const SavingsPage = (props) => {
  const { theme, building, buildingName } = props;
  const { TabPane } = Tabs;
  const [showIncentives, setShowIncentives] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const displayIncentives = await getShouldDisplayIncentives(REACT_APP_BUILD_ENV, building);
      setShowIncentives(displayIncentives);
    }

    fetchData();
  });

  return (
    <div className={`savings-page savings-page-${theme}`}>
      <div className="savings-page-header">
        <div className="savings-page-title">Savings</div>
        <Tabs className={`app-tabs-${theme}`} defaultActiveKey="1">
          <TabPane tab="Overview" key="1">
            <div className="savings-page-content">
              <SavingsHome theme={theme} buildingName={buildingName} />
            </div>
          </TabPane>
          <TabPane tab="Download Report" key="2">
            <DownloadReport theme={theme} buildingName={buildingName} />
          </TabPane>
          {showIncentives && (
            <TabPane tab="Incentives" key="3">
              <Incentives theme={theme} buildingName={buildingName} />
            </TabPane>
          )}
        </Tabs>
      </div>
    </div>
  );
};
